module.exports = __webpack_public_path__ + "img/del.6a0461a6.svg";